(() => {
  const root = document.querySelector('.abrra-page');
  if (!root || root.dataset.abrraEnhanced === 'true') return;
  root.dataset.abrraEnhanced = 'true';

  const menu = root.querySelector('[data-abrra-menu]');
  const openMenu = root.querySelector('[data-abrra-menu-open]');
  const menuClosers = root.querySelectorAll('[data-abrra-menu-close]');
  const menuLinks = root.querySelectorAll('.abrra-nav-drawer a');
  const header = root.querySelector('.abrra-site-header');
  const hero = root.querySelector('.abrra-hero');
  const footerBottle = root.querySelector('[data-abrra-footer-bottle]');
  let menuBottleInitialized = false;

  const syncHeader = () => {
    if (!header || !hero) return;
    const threshold = Math.max(120, hero.offsetHeight - 120);
    header.classList.toggle('is-scrolled', window.scrollY > threshold);

    if (footerBottle) {
      const rect = footerBottle.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const progress = Math.min(1, Math.max(0, (viewportHeight * 0.64 - rect.top) / (viewportHeight * 0.72)));
      footerBottle.style.setProperty('--abrra-footer-bottle-progress', progress.toFixed(4));
      footerBottle.classList.toggle('is-bottle-active', progress > 0 && rect.bottom > viewportHeight * 0.22);
    }
  };

  let syncFrame = 0;
  const requestSync = () => {
    if (syncFrame) return;
    syncFrame = window.requestAnimationFrame(() => {
      syncFrame = 0;
      syncHeader();
    });
  };

  syncHeader();
  window.addEventListener('scroll', requestSync, { passive: true });
  window.addEventListener('resize', requestSync);

  const setMenu = (open) => {
    if (!menu || !openMenu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    openMenu.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('abrra-menu-lock', open);
    if (open && !menuBottleInitialized && window.matchMedia('(min-width: 990px) and (pointer: fine)').matches) {
      menuBottleInitialized = true;
      initMenuBottle3D();
    }
  };

  openMenu?.addEventListener('click', () => setMenu(true));
  menuClosers.forEach((button) => button.addEventListener('click', () => setMenu(false)));
  menuLinks.forEach((link) => link.addEventListener('click', () => setMenu(false)));
  window.addEventListener('pagehide', () => {
    setMenu(false);
    document.body.classList.remove('abrra-cart-lock', 'abrra-product-detail-lock', 'abrra-oil-quiz-lock');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMenu(false);
      setCart(false);
      setOilQuiz(false);
    }
  });

  const cartDrawer = root.querySelector('[data-abrra-cart]');
  const cartOpeners = root.querySelectorAll('[data-abrra-cart-open]');
  const cartClosers = root.querySelectorAll('[data-abrra-cart-close]');
  const cartItems = root.querySelector('[data-abrra-cart-items]');
  const cartTotal = root.querySelector('[data-abrra-cart-total]');
  const cartCounts = document.querySelectorAll('[data-abrra-cart-count]');

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'INR',
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (_error) {
      return `₹${(cents / 100).toFixed(2)}`;
    }
  };

  const setCart = (open) => {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle('is-open', open);
    cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('abrra-cart-lock', open);
    if (open) refreshCart();
  };

  const renderCart = (cart) => {
    cartCounts.forEach((node) => {
      node.textContent = cart.item_count;
    });
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
    if (!cartItems) return;

    if (!cart.items.length) {
      cartItems.innerHTML = '<p class="abrra-cart-drawer__empty">Your cart is empty.</p>';
      return;
    }

    cartItems.innerHTML = cart.items
      .map((item) => {
        const image = item.image
          ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}" loading="lazy">`
          : '<div class="abrra-cart-item__placeholder"></div>';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${item.variant_title}</p>` : '';
        return `
          <article class="abrra-cart-item">
            ${image}
            <div>
              <h3>${item.product_title}</h3>
              ${variant}
              <p>Qty ${item.quantity}</p>
            </div>
            <strong>${money(item.final_line_price)}</strong>
          </article>
        `;
      })
      .join('');
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    renderCart(await response.json());
  };

  cartOpeners.forEach((button) => button.addEventListener('click', () => setCart(true)));
  cartClosers.forEach((button) => button.addEventListener('click', () => setCart(false)));
  refreshCart();

  const animated = root.querySelectorAll('[data-abrra-animate]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.04, rootMargin: '0px 0px -48px' }
    );
    animated.forEach((item) => observer.observe(item));
  } else {
    animated.forEach((item) => item.classList.add('is-visible'));
  }

  const filterButtons = root.querySelectorAll('[data-abrra-filter]');
  const productCards = root.querySelectorAll('[data-abrra-product]');
  const menuFilterLinks = root.querySelectorAll('[data-abrra-menu-filter]');
  const viewMoreButton = root.querySelector('[data-abrra-view-more]');
  let productsExpanded = false;

  const applyProductFilter = (filter = 'all') => {
    let visibleCount = 0;
    let totalMatches = 0;

    filterButtons.forEach((item) => {
      const active = item.dataset.abrraFilter === filter;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    productCards.forEach((card) => {
      const matches = filter === 'all' || card.dataset.category === filter;
      card.classList.remove('is-filter-hidden', 'is-visible-extra');

      if (!matches) {
        card.classList.add('is-filter-hidden');
        return;
      }

      totalMatches += 1;
      visibleCount += 1;
      if (productsExpanded || visibleCount <= 6) {
        card.classList.add('is-visible-extra');
      }
    });

    viewMoreButton?.classList.toggle('is-hidden', productsExpanded || totalMatches <= 6);
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      productsExpanded = false;
      applyProductFilter(button.dataset.abrraFilter);
    });
  });

  menuFilterLinks.forEach((link) => {
    link.addEventListener('click', () => {
      productsExpanded = false;
      applyProductFilter(link.dataset.abrraMenuFilter);
    });
  });

  viewMoreButton?.addEventListener('click', () => {
    productsExpanded = true;
    const activeFilter = root.querySelector('[data-abrra-filter].is-active')?.dataset.abrraFilter || 'haircare';
    applyProductFilter(activeFilter);
  });

  applyProductFilter('haircare');

  const oilQuiz = root.querySelector('[data-abrra-oil-quiz]');
  const oilQuizOpen = root.querySelector('[data-abrra-oil-quiz-open]');
  const oilQuizClosers = root.querySelectorAll('[data-abrra-oil-quiz-close]');
  const oilQuizOptions = root.querySelectorAll('[data-abrra-oil-result]');
  const oilQuizResult = root.querySelector('[data-abrra-oil-quiz-result]');
  const oilRecommendations = {
    coconut: {
      label: 'Coconut Base',
      title: 'Coconut Base Hair Oil',
      copy: 'Best when your hair needs daily nourishment, softness and a smooth shiny finish without heaviness.',
      url: '/products/hair-oil-coconut-base',
    },
    almond: {
      label: 'Almond Base',
      title: 'Almond Base Hair Oil',
      copy: 'Best for rough, dry, wavy or frizz-prone hair that needs richer moisture and comfort.',
      url: '/products/hair-oil-almond-base',
    },
    olive: {
      label: 'Olive Base',
      title: 'Olive Base Hair Oil',
      copy: 'Best for curly, frizzy or dandruff-prone hair when you want scalp care that still feels lightweight.',
      url: '/products/hair-oil-olive-base',
    },
  };

  const setOilQuiz = (open) => {
    if (!oilQuiz) return;
    oilQuiz.classList.toggle('is-open', open);
    oilQuiz.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('abrra-oil-quiz-lock', open);
  };

  const showOilRecommendation = (key) => {
    const recommendation = oilRecommendations[key];
    if (!recommendation || !oilQuizResult) return;
    oilQuizOptions.forEach((option) => {
      option.classList.toggle('is-active', option.dataset.abrraOilResult === key);
    });
    oilQuizResult.innerHTML = `
      <span>${recommendation.label}</span>
      <h3>${recommendation.title}</h3>
      <p>${recommendation.copy}</p>
      <a href="${recommendation.url}">Shop ${recommendation.label}</a>
    `;
  };

  oilQuizOpen?.addEventListener('click', () => setOilQuiz(true));
  oilQuizClosers.forEach((button) => button.addEventListener('click', () => setOilQuiz(false)));
  oilQuizOptions.forEach((button) => {
    button.addEventListener('click', () => showOilRecommendation(button.dataset.abrraOilResult));
  });

  const testimonialStage = root.querySelector('[data-abrra-testimonials]');
  if (testimonialStage) {
    const slides = [...testimonialStage.querySelectorAll('[data-abrra-testimonial]')];
    const dots = [...testimonialStage.querySelectorAll('[data-abrra-testimonial-dot]')];
    const prev = testimonialStage.querySelector('[data-abrra-testimonial-prev]');
    const next = testimonialStage.querySelector('[data-abrra-testimonial-next]');
    let current = 0;
    let timer;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, idx) => slide.classList.toggle('is-active', idx === current));
      dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === current));
    };

    const start = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => show(current + 1), 8000);
    };

    dots.forEach((dot, idx) => dot.addEventListener('click', () => {
      show(idx);
      start();
    }));
    prev?.addEventListener('click', () => {
      show(current - 1);
      start();
    });
    next?.addEventListener('click', () => {
      show(current + 1);
      start();
    });
    show(0);
    start();
  }

  const videoCarousel = root.querySelector('[data-abrra-video-carousel]');
  if (videoCarousel) {
    const track = videoCarousel.querySelector('[data-abrra-video-track]');
    const prev = videoCarousel.querySelector('[data-abrra-video-prev]');
    const next = videoCarousel.querySelector('[data-abrra-video-next]');
    const slides = [...videoCarousel.querySelectorAll('.abrra-video-testimonials__slide')];
    const videos = [...videoCarousel.querySelectorAll('video')];
    let currentVideoSlide = 0;

    const scrollOne = (direction) => {
      if (!track || !slides.length) return;
      currentVideoSlide = Math.max(0, Math.min(slides.length - 1, currentVideoSlide + direction));
      const target = slides[currentVideoSlide];
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const targetLeft = Math.min(target.offsetLeft, maxScroll);
      track.scrollTo({ left: targetLeft, behavior: 'smooth' });
    };

    const syncVideoSlide = () => {
      if (!track || !slides.length) return;
      const trackLeft = track.getBoundingClientRect().left;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      currentVideoSlide = nearestIndex;
    };

    const prepareVideo = (video) => {
      if (video.dataset.abrraPrepared === 'true') return;
      video.dataset.abrraPrepared = 'true';
      video.preload = 'metadata';
      video.load();
    };

    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          prepareVideo(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '320px 0px' });
      videos.forEach((video) => videoObserver.observe(video));
    } else {
      videos.forEach(prepareVideo);
    }

    videos.forEach((video) => {
      video.addEventListener('play', () => {
        videos.forEach((otherVideo) => {
          if (otherVideo !== video) otherVideo.pause();
        });
      });
    });

    prev?.addEventListener('click', () => scrollOne(-1));
    next?.addEventListener('click', () => scrollOne(1));
    track?.addEventListener('scrollend', syncVideoSlide);
    track?.addEventListener('touchend', () => window.setTimeout(syncVideoSlide, 180), { passive: true });
  }

  const initMenuBottle3D = () => {
    const stage = root.querySelector('[data-abrra-menu-bottle-3d]');
    const canvas = stage?.querySelector('canvas');
    if (!stage || !canvas || !window.THREE) return;
    const visual = stage.closest('.abrra-nav-overlay__visual');

    const THREE = window.THREE;
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(26, 1, 0.1, 100);
    camera.position.set(0, 0.08, 6.8);

    const renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true,
      canvas,
      powerPreference: 'high-performance',
      preserveDrawingBuffer: true,
    });
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    if (THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;

    const group = new THREE.Group();
    group.rotation.set(0.06, -0.24, -0.02);
    scene.add(group);

    scene.add(new THREE.HemisphereLight(0xfffbef, 0x2b3f29, 2.2));
    const keyLight = new THREE.DirectionalLight(0xfff4d1, 3.4);
    keyLight.position.set(-3.5, 4.2, 5);
    scene.add(keyLight);
    const rimLight = new THREE.DirectionalLight(0xbed8ff, 1.6);
    rimLight.position.set(3.5, 2.4, -3.5);
    scene.add(rimLight);

    const amber = new THREE.MeshPhysicalMaterial({
      color: 0x5c3518,
      metalness: 0.05,
      roughness: 0.22,
      transmission: 0.12,
      transparent: true,
      opacity: 0.82,
      clearcoat: 0.65,
      clearcoatRoughness: 0.16,
    });
    const glassHighlight = new THREE.MeshPhysicalMaterial({
      color: 0xfff2b8,
      metalness: 0,
      roughness: 0.18,
      transparent: true,
      opacity: 0.26,
      clearcoat: 1,
    });
    const gold = new THREE.MeshStandardMaterial({
      color: 0xd0a134,
      metalness: 0.72,
      roughness: 0.2,
    });
    const dark = new THREE.MeshStandardMaterial({
      color: 0x11100e,
      metalness: 0.3,
      roughness: 0.32,
    });

    const makePart = (geometry, material, position, scale) => {
      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.set(...position);
      mesh.scale.set(...scale);
      group.add(mesh);
      return mesh;
    };

    makePart(new THREE.CylinderGeometry(0.5, 0.55, 2.64, 72), amber, [0, -0.24, 0], [1, 1, 1]);
    makePart(new THREE.SphereGeometry(0.5, 72, 18, 0, Math.PI * 2, 0, Math.PI / 2), amber, [0, 1.08, 0], [1, 0.42, 1]);
    makePart(new THREE.CylinderGeometry(0.23, 0.27, 0.64, 72), amber, [0, 1.42, 0], [1, 1, 1]);
    makePart(new THREE.CylinderGeometry(0.3, 0.33, 0.48, 72), gold, [0, 1.9, 0], [1, 1, 1]);
    makePart(new THREE.CylinderGeometry(0.32, 0.34, 0.08, 72), dark, [0, 1.62, 0], [1, 1, 1]);
    makePart(new THREE.CylinderGeometry(0.53, 0.57, 0.12, 72), glassHighlight, [0, -1.62, 0], [1, 1, 1]);

    for (let i = 0; i < 5; i += 1) {
      makePart(new THREE.TorusGeometry(0.315, 0.008, 8, 72), gold, [0, 1.74 + i * 0.075, 0], [1, 1, 1]).rotation.x = Math.PI / 2;
    }

    const labelCanvas = document.createElement('canvas');
    labelCanvas.width = 768;
    labelCanvas.height = 960;
    const ctx = labelCanvas.getContext('2d');
    ctx.fillStyle = '#fff9ea';
    ctx.fillRect(0, 0, labelCanvas.width, labelCanvas.height);
    ctx.strokeStyle = '#b49242';
    ctx.lineWidth = 18;
    ctx.strokeRect(36, 36, labelCanvas.width - 72, labelCanvas.height - 72);
    ctx.fillStyle = '#4e3326';
    ctx.textAlign = 'center';
    ctx.font = 'italic 96px Georgia, serif';
    ctx.fillText('Abrra', 384, 190);
    ctx.font = '700 62px Arial, sans-serif';
    ctx.fillText('HAIR OIL', 384, 360);
    ctx.font = '700 48px Arial, sans-serif';
    ctx.fillText('MADE WITH', 384, 435);
    ctx.fillText('20+ HERBS', 384, 500);
    ctx.font = '700 58px Georgia, serif';
    ctx.fillText('OLIVE BASE', 384, 610);
    ctx.fillStyle = '#7a8435';
    [[330, 735], [390, 710], [446, 745]].forEach(([x, y]) => {
      ctx.beginPath();
      ctx.ellipse(x, y, 58, 38, -0.3, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.fillStyle = '#3f6f39';
    ctx.beginPath();
    ctx.ellipse(384, 790, 118, 34, -0.18, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#4e3326';
    ctx.font = '700 34px Arial, sans-serif';
    ctx.fillText("MADE WITH MOM'S LOVE", 384, 885);

    const labelTexture = new THREE.CanvasTexture(labelCanvas);
    if (THREE.SRGBColorSpace) labelTexture.colorSpace = THREE.SRGBColorSpace;
    const label = new THREE.Mesh(
      new THREE.CylinderGeometry(0.562, 0.562, 1.34, 64, 1, true, -0.78, 1.56),
      new THREE.MeshBasicMaterial({
        map: labelTexture,
        side: THREE.DoubleSide,
        transparent: true,
      })
    );
    label.position.set(0, -0.36, 0);
    group.add(label);

    const resize = () => {
      const width = Math.max(1, stage.clientWidth);
      const height = Math.max(1, stage.clientHeight);
      renderer.setSize(width, height, false);
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
    };

    let pointerDown = false;
    let lastX = 0;
    let lastY = 0;
    let resumeAt = 0;

    stage.addEventListener('pointerdown', (event) => {
      pointerDown = true;
      lastX = event.clientX;
      lastY = event.clientY;
      resumeAt = Number.POSITIVE_INFINITY;
      stage.setPointerCapture?.(event.pointerId);
    });

    stage.addEventListener('pointermove', (event) => {
      if (!pointerDown) return;
      const deltaX = event.clientX - lastX;
      const deltaY = event.clientY - lastY;
      lastX = event.clientX;
      lastY = event.clientY;
      group.rotation.y += deltaX * 0.01;
      group.rotation.x = Math.max(-0.22, Math.min(0.22, group.rotation.x + deltaY * 0.006));
    });

    const endDrag = (event) => {
      pointerDown = false;
      resumeAt = performance.now() + 1800;
      stage.releasePointerCapture?.(event.pointerId);
    };
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    stage.addEventListener('pointerleave', () => {
      if (!pointerDown) return;
      pointerDown = false;
      resumeAt = performance.now() + 1800;
    });

    const animate = (time = 0) => {
      if (!pointerDown && time > resumeAt) group.rotation.y += 0.007;
      group.position.y = Math.sin(time * 0.0018) * 0.035;
      renderer.render(scene, camera);
      window.requestAnimationFrame(animate);
    };

    resize();
    window.addEventListener('resize', resize);
    visual?.classList.add('is-3d-ready');
    window.requestAnimationFrame(animate);
  };

  // The menu's static product visual is intentional on touch devices. The
  // desktop WebGL bottle is created only after the menu is actually opened.

  root.querySelectorAll('.abrra-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (!button) return;
      button.dataset.originalText = button.dataset.originalText || button.textContent.trim();
      button.textContent = 'Adding...';

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) {
        button.textContent = 'Try again';
        window.setTimeout(() => {
          button.textContent = button.dataset.originalText;
        }, 2000);
        return;
      }

      await refreshCart();
      setCart(true);
      window.setTimeout(() => {
        button.textContent = 'Added';
        button.classList.add('is-added');
      }, 450);
      window.setTimeout(() => {
        button.textContent = button.dataset.originalText;
        button.classList.remove('is-added');
      }, 2200);
    });
  });
})();
